import { IAtBy } from "interfaces/at-by";
import { IEchoEdge } from "interfaces/echo-edge";
import { IEchoFunction } from "interfaces/echo-function";
import { GraphQLData } from "interfaces/graphql-data";
import { IMessageType } from "interfaces/message-type";
import { IEchoNode } from "interfaces/echo-node";
import { ITenant } from "interfaces/tenant";
import { AtByModel } from "models/at-by-model";
import { FunctionModel } from "models/function/function-model";
import { MessageTypeModel } from "models/message-type/messagetype-model";
import { TenantModel } from "models/tenant/tenant-model";

export class ProcessorNodeModel implements IEchoNode, GraphQLData {
  config: string = '';
  created: IAtBy = new AtByModel('', '');
  description: string = '';
  inlineProcessor: string = '';
  lastModified: IAtBy = new AtByModel('', '');
  managedProcessor: IEchoFunction = new FunctionModel();
  name: string = '';
  receiveEdges: Array<IEchoEdge> = new Array<IEchoEdge>();
  receiveMessageType: IMessageType = new MessageTypeModel();
  requirements: Array<string> = new Array<string>();
  sendEdges: Array<IEchoEdge> = new Array<IEchoEdge>();
  sendMessageType: IMessageType = new MessageTypeModel();
  sequentialProcessing: boolean = false;
  tenant: ITenant = new TenantModel();
  typeName: string = '';
  lastEvaluatedKey: string = '';
  scannedCount: number = 0;
  deleted: boolean = false;
  stopped: boolean = false;

  public static createByName(
    name: string,
    typeName: string) : ProcessorNodeModel {
    const t = new ProcessorNodeModel();
    t.name = name;
    t.typeName = typeName;
    return t;
  }

  public static create(
    name: string,
    typeName: string,
    receiveMessageType: IMessageType,
    sendMessageType: IMessageType,
    sendEdges: Array<IEchoEdge>,
    inlineProcessor: string,
    sequentialProcessing: boolean,
    managedProcessor: IEchoFunction,
    requirements: Array<string>,
    description: string,
    stopped: boolean
    ) : ProcessorNodeModel {
    const t = new ProcessorNodeModel();
    t.name = name;
    t.receiveMessageType = receiveMessageType;
    t.sendEdges = sendEdges;
    t.sendMessageType = sendMessageType;
    t.typeName = typeName;
    t.inlineProcessor = inlineProcessor;
    t.sequentialProcessing = sequentialProcessing;
    t.managedProcessor = managedProcessor;
    t.requirements = requirements;
    t.description = description;
    t.stopped = stopped;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    /*if (data && data.data && data.data.GetTenant && data.data.GetTenant.Delete) {
      this.deleted = data.data.GetTenant.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetTenant or data.data.GetTenant.Delete');
    }*/
  }
}